import { render, staticRenderFns } from "./TotalDetail.vue?vue&type=template&id=a2e244c2&scoped=true&"
import script from "./TotalDetail.vue?vue&type=script&lang=js&"
export * from "./TotalDetail.vue?vue&type=script&lang=js&"
import style0 from "./TotalDetail.vue?vue&type=style&index=0&id=a2e244c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e244c2",
  null
  
)

export default component.exports